<template>
  <div>
    <div class="row">
      <div class="col-lg-12">
        <block-cntr
          :btitle="page.blkTitle.igmpSnoopTable"
          style="height: 410px"
        >
          <div class="form-inline">
            <span style="float: left">
              <div class="btn-group open">
                <div
                  @click="editSelectRow"
                  class="btn"
                  :class="{ disabled: false }"
                  style="padding: 0px"
                >
                  <i class="fa fa-edit page-tableaction"></i>
                </div>
              </div>
            </span>
          </div>

          <table class="table table-hover table-noneborder-top">
            <thead>
              <tr>
                <th width="40px">
                  <input
                    type="checkbox"
                    @change="selectall()"
                    v-model="selAll"
                    id="idSelectAll"
                  />
                  <label for="idSelectAll"></label>
                </th>
                <th
                  v-for="(value, key) in igmpSnoopTable.title"
                  :key="key"
                  :title="value"
                >
                  {{ value }}
                </th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="row in portInfo" :key="row.portId">
                <td width="40px">
                  <div>
                    <input
                      type="checkbox"
                      v-model="row.selected"
                      :id="'idRowSelect' + row.portId"
                    />
                    <label :for="'idRowSelect' + row.portId"></label>
                  </div>
                </td>

                <td
                  v-for="(value, key) in printableRow(row)"
                  :key="key"
                  :title="value"
                >
                  <div>{{ value }}</div>
                </td>
              </tr>
            </tbody>
          </table>
        </block-cntr>
        <!--配置操作-->
        <div v-if="isShowAddTable">
          <dialog-box
            :btitle="'IGMP Snooping Config Edit'"
            style="min-height: 100%"
            @close="isShowAddTable = false"
            :closeButton="true"
          >
            <form class="form-horizontal" role="form">
              <div class="form-group">
                <label class="col-sm-3 control-label" for="vlan"
                  >Multicast VLAN</label
                >
                <div class="col-sm-5"  :class="{ 'has-error': input_vlanid_check()}">
                  <input
                    type="text"
                    class="form-control"
                    id="vlan"
                    v-model="igmpForm.mcastVlan"
                    maxlength="4"
                  />
                  <small
                        class="help-block"
                        :style="{
                          display: input_vlanid_check() ? 'block' : 'none',
                        }"
                        >{{ input_vlanid_check() }}
                      </small>
                </div>
              </div>
              <div class="form-group">
                <label class="col-sm-3 control-label" for="recordhost"
                  >Record Host</label
                >
                <div class="col-sm-5">
                  <select
                    class="form-control"
                    id="recordhost"
                    v-model="igmpForm.recordHost"
                  >
                    <option value="0">disable</option>
                    <option value="1">enable</option>
                  </select>
                </div>
              </div>
              <div class="form-group">
                <label class="col-sm-3 control-label" for="dropmode"
                  >Drop Mode</label
                >
                <div class="col-sm-5">
                  <select
                    class="form-control"
                    id="dropmode"
                    v-model="igmpForm.dropMode"
                  >
                    <option value="0">disable</option>
                    <option value="1">query</option>
                    <option value="2">report</option>
                    <option value="3">query/report</option>
                  </select>
                </div>
              </div>
              <button
                type="button"
                class="btn btn-primary"
                style="
                  margin-left: 20%;
                  min-width: 77px;
                  color: #fff;
                  background-color: #008b8b;
                  border-color: #008080;
                "
                @click="clkApply()"
              >
                {{ "Apply" }}
              </button>
              <span style="margin-left: 10px">
                <button
                  type="button"
                  class="btn btn-default"
                  style="min-width: 77px"
                  @click="clkCancel()"
                >
                  {{ "Cancel" }}
                </button>
              </span>
            </form>
          </dialog-box>
        </div>
      </div>
    </div>

    <info-box :ibox="iBox"></info-box>
    <waiting-box visible="showWaitingBoxDiag" msg="'mWaitingMsg'"></waiting-box>
  </div>
</template>

<script>
import en from "./../lang/en-US.js"
import BlockCntr from "./../components/BlockCntr.vue"
import InfoBox from "./../components/InfoBox.vue"
import { get, post } from "@/utils/http.js"
import DialogBox from "@/components/DialogBox"

export default {
  name: "igmpconfig",
  components: {
    BlockCntr,
    InfoBox,
    DialogBox,
  },
  data() {
    return {
      page: en.page.igmpconfig,
      igmpSnoopTable: "",
      tIgmpSnoopTable: "",
      globalIgmpSnoop: 0,
      selAll: false,
      isShowAddTable: false,
      isEditClik: false,
      portInfo: "",
      iBox: {},
      igmpForm: {
        mcastVlan: "",
        recordHost: "0",
        dropMode: "0",
      },
    }
  },
  created() {
    this.loadIgmpSnoop()
  },
  methods: {
    loadIgmpSnoop() {
      get("igmpSnoopTable")
        .then((res) => {
          this.igmpSnoopTable = res.data
          this.dataInit()
          console.log(res.data)
        })
        .catch((err) => {
          this.igmpSnoopTable = en.igmpSnoopTable
          this.dataInit()
        })
    },

    /* 页面数据初始化 */
    dataInit() {
      this.tIgmpSnoopTable = JSON.parse(
        JSON.stringify(this.igmpSnoopTable.data)
      )
      this.tIgmpSnoopTable.forEach((element) => {
        element.portInfo.forEach((elem) => {
          this.$set(elem, "selected", false)
          this.$set(
            elem,
            "mcastVlan",
            elem["mcastVlan"] === "0" ? "" : elem["mcastVlan"]
          )
        })
      })
      this.portInfo = this.tIgmpSnoopTable[0].portInfo
      this.selAll = false
      this.igmpForm.mcastVlan = ""
      this.igmpForm.recordHost = "0"
      this.igmpForm.dropMode = "0"
    },

    /* 页面提交函数 */
    clkApply() {
      var postData = {}
      var editRows = []
      var vt = this.tIgmpSnoopTable[0].portInfo

      vt.forEach((element) => {
        if (element["selected"]) {
          var row = { portId: Number(element["portId"]) }
          row["mcastVlan"] = Number(this.igmpForm.mcastVlan)
          row["recordHost"] = Number(this.igmpForm.recordHost)
          row["dropMode"] = Number(this.igmpForm.dropMode)
          editRows.push(row)
        }
      })

      if (editRows.length) postData["edit"] = editRows
      post("igmpSnoopTable", postData)
        .then((res) => {
          if (
            res.data.code === undefined ||
            (res.data.code === 0 && res.data.msg === undefined)
          )
            this.showAlertBox("info", "Info", "Config successful!")
          else
            this.showAlertBox(
              res.data.code === 0 ? "info" : "warn",
              "Message",
              res.data.msg !== undefined ? res.data.msg : "Unknown error!"
            )
          this.loadIgmpSnoop()
        })
        .catch((err) => {
          this.showAlertBox("critical", "Error", err)
        })

      this.clkCancel()
    },

    /* 页面恢复函数 */
    clkCancel() {
      this.dataInit()
      this.isShowAddTable = false
      this.isEditClik = false
    },

    /* 参数输入检查 */
    input_vlanid_check() {
      if(this.igmpForm.mcastVlan != "")
      {
        var vid = parseInt(this.igmpForm.mcastVlan)
        if (vid < 1 || vid > 4094) return "VLAN ID must be between 1-4094."
      }
      return null
    },

    /* 编辑选择的行 */
    editSelectRow() {
      var vt = this.tIgmpSnoopTable[0].portInfo
      vt.forEach((element) => {
        if (element["selected"]) {
          this.igmpForm.mcastVlan = element.mcastVlan
          if(element.recordHost == "disable")
            this.igmpForm.recordHost = '0'
          else
            this.igmpForm.recordHost = '1'
          if(element.dropMode == "disable")
             this.igmpForm.dropMode = '0'
          else if(element.dropMode == "query")
              this.igmpForm.dropMode = '1'
          else if(element.dropMode == "report")
              this.igmpForm.dropMode = '2'
          else
              this.igmpForm.dropMode = '3'
          this.isShowAddTable = true
          this.isEditClik = true
          return 
        }
      })
    },

    /* 行有效打印 */
    printableRow(row) {
      var prow = {}
      for (var c in row) {
        if (
          c === "rowStatus" ||
          c === "selected" ||
          c === "portId" ||
          c === "newMcastVlan"
        )
          continue
        prow[c] = row[c]
      }
      return prow
    },

    /* 选择全部行 */
    selectall() {
      var vt = this.tIgmpSnoopTable[0].portInfo
      vt.forEach((element) => {
        element["selected"] = this.selAll
      })
    },

    /* 告警弹框 */
    showAlertBox(type, title, txt) {
      this.iBox = {
        visible: true,
        type: type, // info warn critical
        title: title,
        txt: txt,
        btxt: "Close",
      }
    },
  },
}
</script>